module.exports = __webpack_public_path__ + "img/4.351c2730.png";